export default function Header({title}) {
  return (
    <div className="mb-2">
      <h1 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-3">
        <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white text-xl font-bold">
          ₹
        </div>
        {title}
      </h1>
    </div>
  );
}
